import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import ReactRouterPrompt from "react-router-prompt";
import { Modal, Result } from "antd";
import { useI18n } from "../../contexts";
const Prompt = (param)=>{
    let { when, title } = param;
    const { __ } = useI18n();
    const [useTitle, useSubtitle = ""] = useMemo(()=>title.split(".").map((s)=>`${s.trim()}.`), [
        title
    ]);
    return /*#__PURE__*/ _jsx(ReactRouterPrompt, {
        when: when,
        children: (param)=>{
            let { isActive, onConfirm, onCancel } = param;
            return /*#__PURE__*/ _jsx(Modal, {
                open: isActive,
                onCancel: onCancel,
                onOk: onConfirm,
                centered: true,
                okText: __("Leave"),
                cancelText: __("Cancel"),
                children: /*#__PURE__*/ _jsx(Result, {
                    status: "warning",
                    title: useTitle,
                    subTitle: useSubtitle
                })
            });
        }
    });
};
export { Prompt };
